import { createFeatureSelector, createSelector } from "@ngrx/store";
import { packagingFeatureKey } from './packaging.reducer';

export const selectPackagingState = createFeatureSelector(packagingFeatureKey);

export const selectPackaging = createSelector(
  selectPackagingState,
  (state: any) => state
); 
